import { render } from "./BalanceInquiryMenuView.vue?vue&type=template&id=f77aa7cc&scoped=true"
import script from "./BalanceInquiryMenuView.vue?vue&type=script&lang=js"
export * from "./BalanceInquiryMenuView.vue?vue&type=script&lang=js"

import "./BalanceInquiryMenuView.vue?vue&type=style&index=0&id=f77aa7cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77aa7cc"]])

export default __exports__